import { stringUnionToArray } from '@inkitt/types-common';
import type { StripeElementLocale } from '@stripe/stripe-js';

/**
 * Checks if given screen name is a route in the Onboarding Stack Navigator
 * NOTE: This lives in `utils-web` instead of `utils-stripe` since it relies
 * on the client side stripe JS SDK and `utils-stripe` is server only.
 */
export const isStripeLocale = (locale: string): locale is StripeElementLocale =>
  typeof locale === 'string' && stripeLocales.includes(locale as StripeElementLocale);

export const resolveStripeUiLocale = (language: string): StripeElementLocale => {
  const locale = language === 'pt' ? 'pt-BR' : language;
  return isStripeLocale(locale) ? locale : 'auto';
};

const stripeLocales = stringUnionToArray<StripeElementLocale>()(
  'auto',
  'ar',
  'bg',
  'cs',
  'da',
  'de',
  'el',
  'en',
  'en-AU',
  'en-CA',
  'en-NZ',
  'en-GB',
  'es',
  'es-ES',
  'es-419',
  'et',
  'fi',
  'fil',
  'fr',
  'fr-CA',
  'fr-FR',
  'he',
  'hu',
  'hr',
  'id',
  'it',
  'it-IT',
  'ja',
  'ko',
  'lt',
  'lv',
  'ms',
  'mt',
  'nb',
  'nl',
  'no',
  'pl',
  'pt',
  'pt-BR',
  'ro',
  'ru',
  'sk',
  'sl',
  'sv',
  'th',
  'tr',
  'vi',
  'zh',
  'zh-HK',
  'zh-TW',
);
